import React from 'react';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { Button } from '@mui/material';

export const NotAvailable: React.FC = () => (
  <div className="h-screen flex items-center justify-center">
    <div className="flex flex-col items-center space-y-4 text-center p-4">
      <Logo width="100px" />
      <h1 className="text-orange-800 text-4xl font-bold uppercase">Mobile version coming soon</h1>
      <div>
        <p>We are currently developing a mobile-friendly version of our website.</p>
        <p>We will let you know when it&apos;s live!</p>
      </div>
      <Button variant="contained" color="primary" href="https://www.bluecargo.io">
        Go to BlueCargo.io
      </Button>
    </div>
  </div>
);
